export enum PaymentAppType {
    FullCashier = "FullCashier",
    UnifiedCashier = "UnifiedCashier",
}
